export default {
    namespaced: true,
    state: {
        formFields: {},
        companyList: [],
        groupList: [],
        carInfo: {},
    },
    getters: {},
    mutations: {
        setFormFields(state, info) {
            state.formFields = info;
        },
        setCarInfo(state, info) {
            state.carInfo = info;
        },
        setCompanyList(state, info) {
            state.companyList = info;
        },
        setGroupList(state, info) {
            state.groupList = info;
        }
    },
    actions: {}
}
